export const iconFontAwesomeHumanitarianRoadBarrier = (
	<i className="fa-solid fa-road-barrier"></i>
);
